module.exports = __webpack_public_path__ + "img/img2.333770b3.png";